import Switch from './switch';
import './styles/index.scss';
const ExpandedSwitch = Switch;
ExpandedSwitch.displayName = 'Switch';
export default ExpandedSwitch;
